import API, { AUTH_HEADER, GET_AUTH } from 'base/api';
export const FETCH_ALL_STUDENTS = 'FETCH_ALL_STUDENTS';
export const FETCH_ALL_STUDENTS_BEGIN = 'FETCH_ALL_STUDENTS_BEGIN';
export const FETCH_ALL_STUDENTS_SUCCESS = 'FETCH_ALL_STUDENTS_SUCCESS';
export const FETCH_ALL_STUDENTS_ERROR = 'FETCH_ALL_STUDENTS_ERROR';

export const fetchAllStudentsBegin = () => ({
  type: FETCH_ALL_STUDENTS_BEGIN
});

export const fetchAllStudentsSuccess = ( data ) => ({
  type: FETCH_ALL_STUDENTS_SUCCESS,
  payload: { data }
});

export const fetchAllStudentsError = ( error ) => ({
  type: FETCH_ALL_STUDENTS_ERROR,
  payload: { error }
});

export function fetchAllStudents (){
  return dispatch => {
    dispatch(fetchAllStudentsBegin());
    return fetch(API.GET_ALL_STUDENTS, GET_AUTH)
      .then(handleErrors)
      .then(res => res.json())
      .then(json => {
        dispatch(fetchAllStudentsSuccess(json));
        return json;
      })
      .catch(error => dispatch(fetchAllStudentsError(error.message)));
  };
}

function handleErrors(response) {
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response;
}


// WEBPACK FOOTER //
// ./src/modules/Admin/redux/actions/getStudentsAction.js